<div *ngIf="loader" style="height: 200px;">
    <loading ></loading>
</div>

<div *ngIf="!loader && this.bubblemaplinechartdata.length==0" style="height: 300px;text-align: center;place-content: center;">
   <span style="font-size: 18px;font-family: 'Poppins';"> {{ error_name }} </span>
</div>

<div #gridLineChartContainer style="width: 100%;height:100%;"></div>
<!-- Place this in your template file -->
<ng-template  #linesChartTooltip>
  <div class="container chart_tooltip" >
    <!-- Optional: You can add a title here if needed, e.g., the date -->
    <div class="row chart_tooltip_header ">
      <div class="col-12 chart_tooltip_header_data mt-1 mb-1">
        {{mytooltipData?.[0]?.date | date: 'MMM yyyy'}}
      </div>
    </div>

    <div class="mt-1  pb-2">
      <!-- Iterate over the series data -->
      <div class="row" *ngFor="let series of mytooltipData">
        <div class="col-12 d-flex m-auto align-items-center">
          <div>
            <div class="tooltip_outlay" [style.background]="series.colour"></div>
          </div>
          <div class="chart_tooltip_body_data ml-2"> {{ series.label }} : {{ series.value }}</div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
